function getDifficulties(state) {
  return state.games.taboo.difficulties;
}

export default getDifficulties;
